// extracted by mini-css-extract-plugin
export var container = "_hp-0";
export var content = "_hp-3";
export var customerTitle = "_hp-4";
export var empty = "_hp-5";
export var gray = "_hp-6";
export var header = "_hp-7";
export var info = "_hp-8";
export var loading = "_hp-2";
export var loadingCard = "_hp-9";
export var oneLine = "_hp-a";
export var personName = "_hp-e";
export var pillContainer = "_hp-b";
export var selected = "_hp-1";
export var text = "_hp-c";
export var twoLines = "_hp-d";
export var unread = "_hp-f";
export var unreadIndicator = "_hp-g";